import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../core/services/user.service';
import { ValidationService } from '../../../core/services/validation.service';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
// import { FileUploader, FileSelectDirective, FileUploaderOptions } from 'ng2-file-upload/ng2-file-upload';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { HeaderService } from '../../../core/services/header.service';
import { SettingService } from '../../../core/services/setting.service';
import { LocalService } from '../../../core/services/local.service';
import { forkJoin } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../../core/components/confirm-dialog/confirm-dialog.component';
import { LoadingState } from '../../../core/components/loading/loading.component';
@Component({
  selector: 'app-transporter-account',
  templateUrl: './transporter-account.component.html',
  styleUrls: ['./transporter-account.component.scss']
})
export class TransporterAccountComponent implements OnInit {
  @Input() employeeDetails: any;
  loading: LoadingState = LoadingState.NotReady;
	dialogRef: MatDialogRef<ConfirmDialogComponent>;
	form: FormGroup;
	data: any;
	// public uploader: FileUploader;
	// uo: FileUploaderOptions = {};
	public filePreviewPath: SafeUrl;
	fileError: String = '';
	name: any;
	phoneno: any;
	altphoneno: any;
	dob: any;
	image: any = null;
	emp_code: any = null;
	selectedAcademicFile: any = []
	qualificationMaster: any = [];
	toggleAcademicQualification = false;
	toggleLicenses = false;
	toggleOtherDocument = false;
	toggleworkingExp = false;
	academicQualificationDoc: boolean;
	licensesDoc: boolean;
	workingExpDoc: boolean;
	graceLeaves: any
	selectedWorkFile = [];
	selectedLicenceFile = [];
	selectedOtherFile = []
	academicFileTmpArr = [];
	stateList: any = [];
	salayTypeCode: string;
	constructor(
		public formBuilder: FormBuilder,
		public __userService: UserService,
		private toastr: ToastrService,
		private sanitizer: DomSanitizer,
		public router: Router,
		private headerTitleService: HeaderService,
		public dialog: MatDialog,
		private settingService: SettingService,
		private localService: LocalService,
	) {
		
	}

	ngOnInit() {
		this.form = this.formBuilder.group({
			first_name: [null, [Validators.required, ValidationService.NoWhitespaceValidator]],
			last_name: [null, [Validators.required, ValidationService.NoWhitespaceValidator]],
			personal_contact_no: [null, [Validators.required, ValidationService.NoWhitespaceValidator]],			
			personal_email: ['', [
				Validators.required,
				Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
			]],

		});
    this.loading = LoadingState.Ready
		
	}

	changepass() {
		this.router.navigate(['/account/changepassword'])
	}

	updateProfile() {
		if (this.form.valid) {			
			this.loading = LoadingState.Processing;
			const formData: any = new FormData();
			formData.append("first_name", this.form.value.first_name);
			formData.append("last_name", this.form.value.last_name);
			formData.append("email", this.form.value.personal_email);
			formData.append("cu_phone_no", this.form.value.personal_contact_no);
			this.__userService.updateTransporterData(this.localService.getJsonValue('userid'), formData).subscribe(
				(result: any) => {
					this.toastr.success('Data has been saved', '', {
						timeOut: 3000,
					});
					this.loading = LoadingState.Ready;

				},
				error => {
					console.log(error);
					this.loading = LoadingState.Ready;


					if (error.error.error.msg) {
						this.toastr.error(error.error.error.msg, '', {
							timeOut: 3000,
						});
					}
					else {
						this.toastr.error('Something went wrong', '', {
							timeOut: 3000,
						});
					}
				}
			)
		} else {
			this.markFormGroupTouched(this.form)
		}
	}


	markFormGroupTouched(formGroup: FormGroup) {
		(<any>Object).values(formGroup.controls).forEach(control => {
			control.markAsTouched();
			if (control.controls) {
				control.controls.forEach(c => this.markFormGroupTouched(c));
			}
		});
	}

	isFieldValid(form: FormGroup, field: string) {
		return !form.get(field).valid && (form.get(field).dirty || form.get(field).touched);
	}

	displayFieldCss(form: FormGroup, field: string) {
		return {
			'is-invalid': form.get(field).invalid && (form.get(field).dirty || form.get(field).touched),
			'is-valid': form.get(field).valid && (form.get(field).dirty || form.get(field).touched)
		};
	}

}
